const DynamicContent = ({ children }: { children: React.ReactNode }) => {
  return children;
};

export { DynamicContent };
